import React from 'react';
import './Footer.css';

function Footer() {
  const formLink = "https://docs.google.com/forms/d/e/1FAIpQLScONrpxe68j9_Ewugf-nf0lx6wEi6e3bpXlxUGdDwrNCqR-QA/viewform?pli=1";

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-grid">
          {/* İletişim Bilgileri */}
          <div className="footer-section">
            <h4>İletişim</h4>
            <div className="contact-info">
              <p><strong>E-posta:</strong> yonorg2026@gmail.com</p>
              <p><strong>Telefon:</strong> 0346 487 17 37</p>
              <p>Sivas Cumhuriyet Üniversitesi, <br/> İİBF, Sivas/Merkez</p>
              
              <div className="gsm-section">
                <p><strong>Akademik Konular:</strong><br/>
                Dr. Öğretim Üyesi Metin Günay <br/>
                Telefon: 0505 086 36 90</p>
                
                <p><strong>Kayıt ve Konaklama:</strong><br/>
                Elif Durdu <br/>
                Telefon: 0545 360 70 79</p>
              </div>
            </div>
          </div>

          {/* Önemli Linkler */}
          <div className="footer-section">
            <h4>Hızlı Erişim</h4>
            <ul>
              <li><a href={formLink} target="_blank" rel="noopener noreferrer">Bildiri Gönderimi</a></li>
              <li><a href={formLink} target="_blank" rel="noopener noreferrer">Kayıt Formu</a></li>
              <li><a href="/konaklama">Konaklama Bilgileri</a></li>
              <li><a href="/ulasim">Ulaşım</a></li>
            </ul>
          </div>

          {/* Sosyal Medya */}
          <div className="footer-section">
            <h4>Bizi Takip Edin</h4>
            <div className="social-links">
              <a href="https://instagram.com/yonorg2026" target="_blank" rel="noreferrer">Instagram</a> 
              <a href="https://x.com/yonorg2026" target="_blank" rel="noreferrer">X (Twitter)</a> 
              <a href="https://linkedin.com/in/yonorg2026" target="_blank" rel="noreferrer">LinkedIn</a> 
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 34. Ulusal Yönetim ve Organizasyon Kongresi. Tüm Hakları Saklıdır.</p> 
        </div>
      </div>
    </footer>
  )
}

export default Footer;